import React, { useEffect } from 'react';
import { Container, Card, Row, Col, ListGroup, Badge, Spinner, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Leads_Preview_Action } from '../Redux/Actions/MarketingReports_Action';
import { useParams } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaProjectDiagram,
  FaUserAlt,
  FaCalendarAlt,
  FaClock,
} from 'react-icons/fa';
import { Divider, Skeleton, useTheme } from '@mui/material';
import moment from 'moment';
import { db_url } from '../Api/BaseUrl';

export const PreviewLeadDetailsPage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const getdata = async () => {
      await dispatch(Get_All_Leads_Preview_Action(id));
    };
    getdata();
  }, [dispatch, id]);

  const resLeadPreview = useSelector((state) => state.AllMarketingReports.LeadPreview);
  const lead = resLeadPreview?.data;

  // console.log(lead,"lead lead lead")
  const getCleanImageUrl = (filename) => {
    if (!filename) return null;
    // return `https://apirender8.onrender.com/UsersImages/${filename}`;
    return `${db_url}/UsersImages/${filename}`;
  };

  // console.log(resLeadPreview,"resLeadPreview")

  // Function to calculate the difference in days and minutes
  const calculateDuration = (from, to) => {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    const diffInMilliseconds = toDate - fromDate;

    // حساب الأيام
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    // حساب الساعات
    const diffInHours = Math.floor((diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    // حساب الدقائق
    const diffInMinutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));

    return { days: diffInDays, hours: diffInHours, minutes: diffInMinutes };
  };

  if (!lead) {
    return (
      <Container className="startpage text-center">
        <Spinner animation="border" style={{ color: '#102dff' }} />
        <p className="mt-3">Loading Data </p>
      </Container>
    );
  }

  const formatDateTime = (date) => {
    if (!date) return '—';
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  // تنسيق المدة
  const formatDuration = (ms) => {
    if (isNaN(ms)) return '—';

    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    return (
      [
        days > 0 ? `${days}d` : null,
        hours % 24 > 0 ? `${hours % 24}h` : null,
        minutes % 60 > 0 ? `${minutes % 60}m` : null,
        seconds % 60 > 0 ? `${seconds % 60}s` : null,
      ]
        .filter(Boolean)
        .join(' ') || '0s'
    );
  };

  return (
    <Container className=" fade-in" style={{ marginTop: '100px' }}>
      <h2 className="text-center fw-bold mb-4 " style={{ color: '#102dff' }}>
        {' '}
        Lead Full Preview
      </h2>

      {/* Basic Info */}
      <div
        className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100"
        style={{
          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
          color: mode === 'dark' ? '#e0e0e0' : '#333333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h5 className="mb-4 fw-bold text-primary">
          <span className="text-decoration-underline" style={{ color: '#102dff' }}>
            Basic Information
          </span>
        </h5>
        <Row className="gy-3 gx-4">
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaUserAlt className="text-info me-2" />
              <strong>Name:</strong> {lead.name}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaPhone className="text-success me-2" />
              <strong>Phone:</strong> {lead.phone}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaEnvelope className="text-danger me-2" />
              <strong>Email:</strong> {lead.email}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaProjectDiagram className="text-warning me-2" />
              <strong>Project:</strong> {lead.project}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaUserAlt className="text-primary me-2" />
              <strong>Developer:</strong> {lead?.developer?.name}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <FaCalendarAlt className="text-secondary me-2" />
              <strong>Created At:</strong>{' '}
              {lead ? (
                moment(lead.createdAt).format('DD/MM/YYYY h:mm A')
              ) : (
                <Skeleton animation="wave" />
              )}{' '}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <strong>Current Sales:</strong>{' '}
              <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">
                {lead.currentSales}
              </Badge>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <strong>Last Sales:</strong>{' '}
              <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">
                {lead.lastSales}
              </Badge>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex align-items-center">
              <strong>Last Date Assigned:</strong>{' '}
              <Badge bg="secondary" className="px-2 py-1 rounded-pill ms-2">
                {lead ? (
                  moment(lead.lastdateusedtoassigned).format('DD/MM/YYYY h:mm A')
                ) : (
                  <Skeleton animation="wave" />
                )}
              </Badge>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100"
        style={{
          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
          color: mode === 'dark' ? '#e0e0e0' : '#333333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h5 className="mb-4 fw-bold text-primary">
          <span className="text-decoration-underline" style={{ color: '#102dff' }}>
            Lead With Sales (Period)
          </span>
        </h5>

        <Row xs={1} md={2} lg={3} className="g-4">
          {lead.salesAssignDurations.map((sales, idx) => (
            <Col key={`${sales.name}-${idx}`}>
              <Card
                className="shadow rounded h-100 w-100"
                style={{
                  background: mode === 'dark' ? '#333' : '#fff',
                  color: mode === 'dark' ? '#fff' : '#333',
                }}
              >
                <div className="d-flex flex-column w-100">
                  <Card.Title
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#333',
                    }}
                  >
                    <span>{sales.name}</span>
                    <Badge style={{ background: '#666' }} pill>
                      {sales.periods.length} {sales.periods.length > 1 ? 'Periods' : 'Period'}
                    </Badge>
                  </Card.Title>

                  <Card.Subtitle
                    className="mb-3 "
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#333',
                    }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      <FaClock
                        className="me-2"
                        style={{
                          background: mode === 'dark' ? '#333' : '#fff',
                          color: mode === 'dark' ? '#fff' : '#333',
                        }}
                      />
                      Total: {sales.totalDuration}
                    </div>
                  </Card.Subtitle>

                  <hr />

                  <div
                    className="flex-grow-1 overflow-auto"
                    style={{
                      maxHeight: '300px',
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#333',
                    }}
                  >
                    <h6
                      className="fw-bold"
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      Period Details:
                    </h6>
                    <ListGroup
                      variant="flush"
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {sales.periods.map((p, i) => (
                        <ListGroup.Item
                          key={i}
                          className="py-2 px-0"
                          style={{
                            background: mode === 'dark' ? '#333' : '#fff',
                            color: mode === 'dark' ? '#fff' : '#333',
                          }}
                        >
                          <div
                            className="d-flex justify-content-between small mb-1"
                            style={{
                              background: mode === 'dark' ? '#333' : '#fff',
                              color: mode === 'dark' ? '#fff' : '#333',
                            }}
                          >
                            <span
                              className=""
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              From:
                            </span>
                            <strong
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              {new Date(p.from).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </strong>
                          </div>

                          <div
                            className="d-flex justify-content-between small mb-1"
                            style={{
                              background: mode === 'dark' ? '#333' : '#fff',
                              color: mode === 'dark' ? '#fff' : '#333',
                            }}
                          >
                            <span
                              className=""
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              To:
                            </span>
                            <strong
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              {new Date(p.to).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </strong>
                          </div>

                          <div
                            className="d-flex justify-content-between small"
                            style={{
                              background: mode === 'dark' ? '#333' : '#fff',
                              color: mode === 'dark' ? '#fff' : '#333',
                            }}
                          >
                            <span
                              className=""
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              Duration:
                            </span>
                            <Badge bg="info" className="text-dark">
                              {p.durationStr}
                            </Badge>
                          </div>

                          {i < sales.periods.length - 1 && <hr className="my-2" />}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Sales Durations */}
      {lead.salesDurations && (
        <div
          className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100 my-4"
          style={{
            backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
            color: mode === 'dark' ? '#e0e0e0' : '#333333',
          }}
        >
          <h5 className="mb-4 fw-bold text-primary">
            <span className="text-decoration-underline" style={{ color: '#102dff' }}>
              Stages Durations (Full)
            </span>
          </h5>

          <Row className="gy-4">
            {Object.entries(lead.salesDurations).map(([salesId, salesData], index) => {
              const currentSalesName = salesData.name;

              // 1. البحث عن آخر assign لهذا الـ sales
              const lastAssignForThisSales = lead.allAssignPeriods
                ?.filter((p) => p.salesName === currentSalesName)
                ?.sort((a, b) => new Date(b.from) - new Date(a.from))[0];

              return (
                <Col xs={12} key={`${salesId}-${index}`}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold text-secondary mb-0">👤 Sales: {salesData.name}</h6>
                    <Badge style={{ background: '#102dff' }} className="fs-6">
                      {salesData.interactions?.length || 0} Stages
                    </Badge>
                  </div>

                  {salesData.interactions?.length > 0 ? (
                    <div className="table-responsive">
                      <table
                        className="table table-bordered"
                        style={{
                          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
                          color: mode === 'dark' ? '#e0e0e0' : '#212529',
                        }}
                      >
                        <thead
                          style={{
                            backgroundColor: mode === 'dark' ? '#3d3d3d' : '#f8f9fa',
                            color: mode === 'dark' ? '#ffffff' : '#000000',
                          }}
                        >
                          <tr>
                            <th
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              {' '}
                              Stage
                            </th>
                            <th
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              From
                            </th>
                            <th
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              To
                            </th>
                            <th
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              Duration
                            </th>
                            <th
                              style={{
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {salesData.interactions.map((interaction, idx) => {
                            const from = new Date(interaction.from);
                            let to = new Date(interaction.to);
                            let status = 'Completed';

                            if (idx === salesData.interactions.length - 1) {
                              const nextAssign = lead.allAssignPeriods?.find(
                                (p) => new Date(p.from) > new Date(lastAssignForThisSales?.from),
                              );

                              if (nextAssign) {
                                to = new Date(lastAssignForThisSales?.to || interaction.to);
                                status = 'Ended by Reassignment';
                              } else if (!interaction.to) {
                                status = 'Current Stage';
                              }
                            }

                            const durationMs = to - from;
                            const durationStr = formatDuration(durationMs);

                            return (
                              <tr
                                key={idx}
                                style={{
                                  backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
                                  color: mode === 'dark' ? '#cccccc' : '#212529',
                                }}
                              >
                                <td
                                  style={{
                                    background: mode === 'dark' ? '#333' : '#fff',
                                    color: mode === 'dark' ? '#fff' : '#333',
                                  }}
                                >
                                  {interaction.stage}
                                </td>
                                <td
                                  style={{
                                    background: mode === 'dark' ? '#333' : '#fff',
                                    color: mode === 'dark' ? '#fff' : '#333',
                                  }}
                                >
                                  {formatDateTime(from)}
                                </td>
                                <td
                                  style={{
                                    background: mode === 'dark' ? '#333' : '#fff',
                                    color: mode === 'dark' ? '#fff' : '#333',
                                  }}
                                >
                                  {to ? formatDateTime(to) : 'Current'}
                                </td>
                                <td
                                  style={{
                                    background: mode === 'dark' ? '#333' : '#fff',
                                    color: mode === 'dark' ? '#fff' : '#333',
                                  }}
                                >
                                  {durationStr}
                                </td>
                                <td
                                  style={{
                                    background: mode === 'dark' ? '#333' : '#fff',
                                    color: mode === 'dark' ? '#fff' : '#333',
                                  }}
                                >
                                  <Badge
                                    bg={
                                      status === 'Completed'
                                        ? 'success'
                                        : status === 'Ended by Reassignment'
                                          ? 'dark'
                                          : 'primary'
                                    }
                                  >
                                    {status}
                                  </Badge>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div
                      className="p-3 rounded"
                      style={{
                        backgroundColor: mode === 'dark' ? '#444' : '#f8f9fa',
                        color: mode === 'dark' ? '#ccc' : '#666',
                      }}
                    >
                      No stages found for this sales.
                    </div>
                  )}

                  {/* معلومات الـ Assignment */}
                  {lastAssignForThisSales && (
                    <div
                      className="mt-3 p-3 rounded"
                      style={{
                        backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
                        color: mode === 'dark' ? '#e0e0e0' : '#333333',
                        border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <span className="fw-bold">Last Assignment Period:</span>
                        <Badge
                          bg={mode === 'dark' ? 'light' : 'secondary'}
                          text={mode === 'dark' ? 'dark' : 'white'}
                        >
                          {formatDuration(
                            new Date(lastAssignForThisSales.to || new Date()) -
                              new Date(lastAssignForThisSales.from),
                          )}
                        </Badge>
                      </div>
                      <div className="small mt-2">
                        <span style={{ color: mode === 'dark' ? '#aaaaaa' : '#666' }}>From:</span>{' '}
                        {formatDateTime(new Date(lastAssignForThisSales.from))}
                        <br />
                        <span style={{ color: mode === 'dark' ? '#aaaaaa' : '#666' }}>
                          To:
                        </span>{' '}
                        {lastAssignForThisSales.to
                          ? formatDateTime(new Date(lastAssignForThisSales.to))
                          : 'Current'}
                      </div>
                    </div>
                  )}
                </Col>
              );
            })}
          </Row>
        </div>
      )}
      {/* Stages Passed */}
      <div
        className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100"
        style={{
          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
          color: mode === 'dark' ? '#e0e0e0' : '#333333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h5 className="mt-2 mb-3 fw-bold text-primary">
          <span className="text-decoration-underline" style={{ color: '#102dff' }}>
            Stages Passed
          </span>
        </h5>
        <Row className="gy-3 gx-4">
          {lead.stagesPassed?.map((stage, index) => (
            <Col xs={12} md={4} key={index}>
              <Card
                className="shadow-sm border-0 "
                style={{
                  background: mode === 'dark' ? '#333' : '#fff',
                  color: mode === 'dark' ? '#fff' : '#333',
                }}
              >
                <Card.Body>
                  <Card.Title className="fw-bold " style={{ color: '#666' }}>
                    {stage.stage}
                  </Card.Title>
                  <Card.Subtitle
                    className="mb-2 "
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#333',
                    }}
                  >
                    {stage ? (
                      moment(stage.date).format('DD/MM/YYYY')
                    ) : (
                      <Skeleton animation="wave" />
                    )}
                  </Card.Subtitle>
                  <Card.Text>
                    <strong>Sales:</strong> {stage.sales}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Comments Section */}
      <div
        className="mb-4 shadow-lg rounded-4 p-4 border-0 w-100"
        style={{
          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
          color: mode === 'dark' ? '#e0e0e0' : '#333333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h5 className="mt-2 mb-3 fw-bold text-primary">
          <span className="text-decoration-underline" style={{ color: '#102dff' }}>
            Comments ({lead.comments?.length || 0})
          </span>
        </h5>

        <div style={{ maxHeight: '600px', overflowY: 'auto', paddingRight: '10px' }}>
          <Row className="gy-3 gx-4">
            {lead.comments?.map((comment, index) => (
              <Col xs={12} key={index}>
                <div className="mb-4">
                  {/* First Comment */}
                  <div className="d-flex align-items-start mb-3">
                    <Badge style={{ background: '#102dff' }} className="me-2">
                      Comment
                    </Badge>
                    <Image
                      src={
                        comment.sales.profileImg
                          ? getCleanImageUrl(comment.sales.profileImg)
                          : 'path/to/default-image.jpg'
                      }
                      alt={comment.sales.name}
                      roundedCircle
                      width={40}
                      height={40}
                      className="me-3"
                    />
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <strong style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
                            {' '}
                            {index + 1}. {comment.sales.name}
                          </strong>
                          <div
                            className=""
                            style={{
                              fontSize: '0.85rem',
                              color: mode === 'dark' ? '#fff' : '#333',
                            }}
                          >
                            {comment.sales.email}
                          </div>
                        </div>
                        <small className="" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
                          {new Date(comment.firstcomment.date).toLocaleString()}
                        </small>
                      </div>
                      <div
                        className=" p-3 rounded-3 mt-2"
                        style={{
                          maxWidth: '75%',
                          background: mode === 'dark' ? '#333' : '#fff',
                          color: mode === 'dark' ? '#fff' : '#333',
                        }}
                      >
                        <p className="mb-0" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
                          {comment.firstcomment.text}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second Comment */}
                  {comment.secondcomment && (
                    <div className="d-flex align-items-start mb-3 ms-5">
                      <Badge style={{ background: '#102dff' }} className="me-2">
                        Next Action
                      </Badge>

                      <Image
                        src={
                          comment.sales.profileImg
                            ? getCleanImageUrl(comment.sales.profileImg)
                            : 'path/to/default-image.jpg'
                        }
                        alt={comment.sales.name}
                        roundedCircle
                        width={35}
                        height={35}
                        className="me-3"
                      />
                      <div className="w-100">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
                              {comment.sales.name}
                            </strong>
                            <div
                              className=""
                              style={{
                                fontSize: '0.8rem',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              {comment.sales.email}
                            </div>
                          </div>
                          <small style={{ color: mode === 'dark' ? '#fff' : '#333' }} className="">
                            {new Date(comment.secondcomment.date).toLocaleString()}
                          </small>
                        </div>
                        <div
                          className=" p-3 rounded-3 mt-2"
                          style={{
                            maxWidth: '70%',
                            background: mode === 'dark' ? '#333' : '#fff',
                            color: mode === 'dark' ? '#fff' : '#333',
                          }}
                        >
                          <p style={{ color: mode === 'dark' ? '#fff' : '#333' }} className="mb-0">
                            {comment.secondcomment.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  <Divider />
                  {/* Replies */}
                  {comment.replies?.length > 0 && (
                    <div className="ms-5 mt-3">
                      <h6 className="text-secondary fw-bold mb-2">
                        Replies ({comment.replies.length})
                      </h6>
                      {comment.replies.map((reply, idx) => (
                        <div className="d-flex align-items-start mb-3 ms-4" key={idx}>
                          <Image
                            src={
                              reply?.user?.profileImg
                                ? getCleanImageUrl(reply?.user?.profileImg)
                                : 'path/to/default-image.jpg'
                            }
                            alt={reply?.user?.name}
                            roundedCircle
                            width={32}
                            height={32}
                            className="me-3"
                          />
                          <div className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <strong>{reply.user.name}</strong>
                                <span className="badge bg-light text-dark ms-2">Reply</span>
                              </div>
                              <small
                                style={{ color: mode === 'dark' ? '#fff' : '#333' }}
                                className=""
                              >
                                {new Date(reply.date).toLocaleString()}
                              </small>
                            </div>
                            <div
                              className=" p-2 rounded-3 mt-2"
                              style={{
                                maxWidth: '65%',
                                background: mode === 'dark' ? '#333' : '#fff',
                                color: mode === 'dark' ? '#fff' : '#333',
                              }}
                            >
                              <p
                                style={{ color: mode === 'dark' ? '#fff' : '#333' }}
                                className="mb-0"
                              >
                                {reply.text}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <hr />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Container>
  );
};
